
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './sign-in.css';
import Input from '@hig/input';
import Tooltip from '@hig/tooltip';
import Button from '@hig/button';
import { signIn, loadProfile, signOut } from '../../actions/profileActions';



export class SignIn    extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            username: "",   
            password: "",

        };
    }


    onEditChange = (e) => {

        this.setState({ [e.target.name]: e.target.value });

    }

    onSignIn = () => {


        console.log("Signing in with ", this.state);

        this.props.signIn(this.state.username, this.state.password);
        this.props.loadProfile();
        
    }

    onSignOut = () => {

        this.props.signOut();

    }

    render() {
        return (
            <div className="sign-in-container">
                <button
                    style={{ display: !this.props.isLoggedIn ? 'block' : 'none' }}
                    className="sign-in-button" onClick={() => this.setState({ showForm: !this.state.showForm })}>
                    <span className="material-symbols-outlined">
                        person
                    </span>
                    <span>
                        Zaloguj się
                    </span>
                </button>
                <div style={{ display: this.state.showForm && !this.props.isLoggedIn ? 'block' : 'none' }}
                    className="sign-in-form">
                    <div>
                        <label htmlFor="username">Nazwa użytkownika</label>
                        <Input 
                            id="username"
                            name="username"
                            onBlur={null}
                            onChange={this.onEditChange}
                            onMouseEnter={null}
                            onMouseLeave={null}
                            variant="box"
                            value={this.username}
                        />
                    </div>
                    <div>
                        <label htmlFor="password">Hasło</label>
                        <Input
                            id="password"
                            name="password"
                            onBlur={null}
                            onChange={this.onEditChange}
                            onMouseEnter={null}
                            onMouseLeave={null}
                            variant="box"
                            value={this.password}
                            type="password"
                        />

                    </div>
                    <div style={{ padding: "10px", display:"flex", justifyContent: "center" }}>
                        <Button style={{ width: '125px' }}
                            size="standard"
                            title="Zaloguj"
                            type="secondary"
                            width="grow"
                            onClick={this.onSignIn}
                        />
                    </div>


                </div>
                <div style={{ display: this.props.isLoggedIn ? 'block' : 'none' }} className="welcome-message">
                    
                    <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
                        <Button style={{ width: '125px' }}
                            size="standard"
                            title="Wyloguj"
                            type="secondary"
                            width="grow"
                            onClick={this.onSignOut}
                        />
                    </div>
                </div>
            </div>
        );

    }

}

export default connect(function (store) {
    return {
        isLoggedIn: store.profile.isLoggedIn,
    };
}, { signIn, loadProfile, signOut })(SignIn);